import { createSelector } from 'reselect'
import DOOR_TO_DOOR_PARTNERS from '@/shared/config/doorToDoorPartners'

export const selectPageConfiguration = state => state.pageConfiguration

export const selectPageConfigurationData = createSelector(
  selectPageConfiguration,
  pageConfiguration => pageConfiguration.data,
)

export const selectPageConfigurationError = createSelector(
  selectPageConfiguration,
  pageConfiguration => pageConfiguration.error,
)

export const selectPageConfigurationIsLoading = createSelector(
  selectPageConfiguration,
  pageConfiguration => pageConfiguration.isLoading,
)

export const selectPageConfigurationIsInitialized = createSelector(
  selectPageConfiguration,
  pageConfiguration => pageConfiguration.isInitialized,
)

export const selectDoorToDoorPartner = createSelector(
  selectPageConfigurationData,
  data => {
    const ls = (data?.contact?.lead_source ?? '').toLowerCase()
    return DOOR_TO_DOOR_PARTNERS.find(partner => partner.leadSourceMatcher(ls)) ?? null
  },
)

export const selectIsDoorToDoorPartner = createSelector(
  selectDoorToDoorPartner,
  partner => partner !== null,
)

// List of MCP advisors exposed by the backend alongside elmy_mminimal_start_date
// and save_route. Each entry has the shape { id, firstname, name }. Used by
// the McpAdvisor picker on the Client tab (Selectra admin + FR only).
export const selectMcpUsers = createSelector(
  selectPageConfigurationData,
  data => data?.mcp_users ?? [],
)

